import React, { useEffect, useState } from "react";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { UserInvite } from "../../Models/UserInvite";
import { useTranslation } from "react-i18next";


const SelectInviteUsers: React.FunctionComponent<{ onInviteUser: any }> = (props) => {

    const [userValue, setUserValue] = useState<UserInvite>({
        accountId: localStorage.getItem('id'),
        statu: false
    })
    const { t } = useTranslation();

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setUserValue((prev) => ({ ...prev, [name]: value }));
    }

    const invite = () => {
        props.onInviteUser(userValue);
    }

    return (
        <>
            <div className="manager-header mb-4">
                <h2 className="manager-title">{t("users.inviteUsers")}</h2>
            </div>
            <div className="row col-users ">
                <div className="col-md-6 mb-3">
                    <label htmlFor="User Name" className="form-label ">{t("users.userName")}</label>
                    <input type="text" className="form-control input-settings" placeholder={t("users.userName")} name="lastename" value={userValue?.lastename || ""} onChange={handleChange} />
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="User Email" className="form-label ">{t("users.userEmail")}</label>
                    <input type="email" className="form-control input-settings" placeholder={t("users.userEmail")} name="email" value={userValue?.email || ""} onChange={handleChange} />
                </div>
            </div>
            <div className="row col-users">
                <div className="col-md-6 mb-3">
                    <label htmlFor="User Rule" className="form-label ">{t("users.userRule")}</label>
                    <FormControl fullWidth>
                        <Select
                            className="input-settings border-ced4da"
                            displayEmpty
                            name="rule"
                            value={userValue?.rule || ''}
                            inputProps={{ 'aria-label': 'Select' }}
                            onChange={handleChange}>
                            <MenuItem value="" disabled>
                                {t("propertiesPage.select")}
                            </MenuItem>
                            <MenuItem value="Admin" >
                                {t("users.admin")}
                            </MenuItem>
                            <MenuItem value="Agent" >
                                {t("users.agent")}
                            </MenuItem>
                            <MenuItem value="Moderator" >
                                {t("users.moderator")}
                            </MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className="col-md-6  mb-3">
                    <label htmlFor="Enhance Photos" className="form-label ">{t("users.enhancePhotosLabel")}</label>
                    <input type="number" min={0} className="form-control input-settings" placeholder="0" name="enhancephotos" value={userValue?.enhancephotos} onChange={handleChange} />
                </div>
            </div>
            <div className="row col-users">
                <div className="col-md-6  mb-3">
                    <label htmlFor="Generate Photos" className="form-label ">{t("users.generatePhotosLabel")}</label>
                    <input type="number" min={0} className="form-control input-settings" placeholder="0" name="generatephotos" value={userValue?.generatephotos} onChange={handleChange} />
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="Listings" className="form-label ">{t("navbar.balanceCard.listings")}</label>
                    <input type="number" min={0} className="form-control input-settings" placeholder="0" name="listings" value={userValue?.listings} onChange={handleChange} />
                </div>
            </div>

            <button type="button" className={`button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 ${userValue?.email && userValue?.lastename && userValue?.rule && userValue?.enhancephotos && userValue?.generatephotos && userValue?.listings ? "" : 'disabled'}`} onClick={invite}>
                {t("users.invite")}</button>
        </>
    )
}
export default SelectInviteUsers
